export default __webpack_public_path__ + "9b942142cc33a348232a6fc7964fa489.svg";